/** @typedef {{
 *  mode: WorkflowMode,
 *  selection: SelectionState,
 *  diagramChanges: ChangesState,
 *  zoomScale: number|string,
 }} CanvasConfig
 */

/**
 * Generates a canvas configuration object.
 * @param {number|string} zoomScale - The zoom scale of the canvas.
 * @param {SelectionState} selection - The current selection state of the canvas.
 * @param {ChangesState} diagramChanges - The state representing changes in the diagram.
 * @param {WorkflowMode} mode - The current mode of the canvas (e.g., 'edit' or 'view').
 * @returns {CanvasConfig} The canvas configuration object.
 */
export const getCanvasConfig = (zoomScale, selection, diagramChanges, mode, mockMode) => {
  return {
    zoomScale,
    selection,
    diagramChanges,
    mode,
    mockMode
  }
}
